export const darkTheme = {
  BACKGROUND_COLOR: "#353c51",
  TEXT_COLOR: "#f3cfd5",
  CARD: "#90AACB",
  CARD_TITLE: "#353c51",
  BUTTON_COLOR: "#90AACB",
};
export const lightTheme = {
  BACKGROUND_COLOR: "#ffefd5",
  TEXT_COLOR: "#34516e",
  CARD: "#F4BEEE",
  CARD_TITLE: "#34516e",
  BUTTON_COLOR: "#EA99D5",
};

// export { CardContainer, CardBody, ImgContainer, Img, Title, Text, CardButton };
